import React, { useMemo } from 'react';
import clsx from 'clsx';

const useNamedBlocks = children => {
  const arr = React.Children.toArray(children);

  return component => {
    return arr.filter(child => child.type.name === component.name);
  };
};

export function BreadcrumbLink({
  children,
  className,
  isCurrentPage,
  ...rest
}) {
  const classNames = useMemo(
    () =>
      clsx(
        'no-underline focus:outline-none border-0 border-solid border-b border-transparent focus-visible:border-black hover:cursor-pointer hover:border-black',
        className,
        {
          'text-dark-gray': !isCurrentPage,
          'text-black': isCurrentPage
        }
      ),
    [className, isCurrentPage]
  );

  if (isCurrentPage) {
    return (
      <span aria-current="page" className={classNames} {...rest}>
        {children}
      </span>
    );
  }
  return (
    <a className={classNames} {...rest}>
      {children}
    </a>
  );
}

export function BreadcrumbItem({ children, className, ...rest }) {
  const findChild = useNamedBlocks(children);

  return (
    <li
      className={clsx(
        "flex shrink-0 before:mr-2 before:w-auto before:text-dark-gray before:content-['›'] first:before:mr-0 first:before:content-none",
        className
      )}
      {...rest}
    >
      {findChild(BreadcrumbLink)}
    </li>
  );
}

export default function Breadcrumb({ children, className, ...rest }) {
  const findChild = useNamedBlocks(children);

  return (
    <nav aria-label="Breadcrumb" className={clsx(className)} {...rest}>
      <ol className="m-0 flex list-none space-x-2 p-0 text-sm">
        {findChild(BreadcrumbItem)}
      </ol>
    </nav>
  );
}
